const s: any = 'Loading...';
export const loadingHtml: any[] = [
  {
    h: 'div', c: 'sk-loading', id: 'sk-loading',
    s: [
      {
        h: 'div', c: 'sk-loading-wrap',
        s: [
          {
            h: 'div', c: 'sk-loading-row',
            s: [
              {
                h: 'div', c: 'sk-loading-spin',
                s: [
                  {h: 'span', c: 'sk-loading-item'},
                  {h: 'span', c: 'sk-loading-item'},
                  {h: 'span', c: 'sk-loading-item'},
                  {h: 'span', c: 'sk-loading-item'}
                ]
              }
            ]
          },
          {
            h: 'div', c: 'sk-loading-text',
            lf: <T>(o: T = s): T => {
              return o as T;
            }
          }
        ]
      }
    ]
  }
];